<template>
    <div class="picbook-box">
        <div class="content">
            <picbook
                :picbookData="picbookData"
                :route-name="'studyReport'"
                :playBtnImgUrl="playBtnImgUrl"
            />
        </div>
    </div>
</template>

<script setup>
import {ref, toRefs, toRef, defineProps, onMounted, defineAsyncComponent} from 'vue';

const props = defineProps(['pageData']);
console.log('props.pageData.opusDetectiveInfo', props.pageData.opusDetectiveInfo);
const {opusPicbookUrl, opusQuestions} = props.pageData.opusDetectiveInfo;

const data = opusQuestions.map(item => item.voiceUrl);
const picbookData = ref(data);
const playBtnImgUrl = ref(props.pageData.playBtnImgUrl);

const arr = opusPicbookUrl.split('?')[0]?.split('/');
const picbook = defineAsyncComponent(() =>
    import(`../../picbook/${arr[arr.length - 1]}.vue`)
);
</script>

<style lang="scss" scoped>
.picbook-box {
    width: 33.8vh;
    height: 19.02vh;
    border-radius: 1.7vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;

    .content {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        z-index: 1;
    }
}
</style>
